import type { BetSlipState } from '../types';

const betLevelErrorDismissed = (state: BetSlipState): BetSlipState => ({
  ...state,
  errorResponse: undefined
});

export default betLevelErrorDismissed;
